export default __webpack_public_path__ + "static/media/bmw.e0c5156b.png";